/**
 * Sendgrid fails to send if the recipient list contains less than the MINIMUM_RECIPIENT_COUNT.
 *
 * @see https://digitalstack.atlassian.net/browse/DS-8770
 */
export const SEND_GRID_MINIMUM_RECIPIENT_COUNT = 2;
